/**
 * Component; X_Ajax_WP_Query
 *
 * @uses axios
 */

var co_ajax_wp_query_init = function() {
  var components = document.querySelectorAll('.js-co-ajax');
  if (components.length) {
    for (var i = 0; i < components.length; i++) {

      // @todo fix function applying multiple times (pagination)
      co_ajax_wp_query({
        'selector_wrapper'                : '#' + components[i].getAttribute('id'),
        'selector_items'                  : '.js-co-ajax__items',
        'selector_pagination'             : '.js-co-ajax__pagination__button',
        'selector_pagination_container'   : '.js-co-ajax__pagination',
        'selector_filters'                : '.js-co-ajax__filters',
        'selector_filter_items'           : '.js-co-ajax__filter__item__link',
        'selector_filter_toggles'         : '.js-co-ajax__filter__toggle',
        'selector_form_wrapper'           : '.js-co-ajax__form',
        'selector_form'                   : '.js-ajax-wp-query-form',
        'selector_progress'               : '.js-co-ajax__progress',
        'selector_hero'                   : '.js-ajax-hero',
        'wrapper'                         : components[i]
      });


    }
  }
};

/**
 * Capsulate functionality
 */
var co_ajax_wp_query = function(args) {

  var state = '';
  var el = {};

  /**
   * Validate args
   */
  if (args.wrapper === null) {
    console.log('Invalid AJAX component');
    return;
  }

  /**
   * Helper: Insert node after other node
   */
  function _el_insert_after(new_node, reference_node) {
    reference_node.parentNode.insertBefore(new_node, reference_node.nextSibling);
  }

  /**
   * Helper: Return $_GET variable by key
   */
  function _get_parameter_by_name(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  /**
   * Helper: Update URL query string $_GET variable
   *
   * @see https://stackoverflow.com/a/6021027
   */
  function _update_query_string_parameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      return uri + separator + key + "=" + value;
    }
  }

  /**
   * AJAX executer
   *
   * @param array params
   */
  var run = function(params) {


    // prevent simultation requests
    if (state !== 'fetching' && typeof axios !== 'undefined') {
      state = 'fetching';

      // set ajax "state"
      el.wrapper.classList.add('state--loading');
      if (params.replace_items) {
        el.wrapper.classList.add('state--loading-big');
      }

      axios.get(params.target_url)
        .then(function (response) {

          /**
           * Parse response into HTML DOM
           */
          var parser = new DOMParser();
          var html = parser.parseFromString(response.data, "text/html");

          var new_wrapper = html.querySelector(args.selector_wrapper);

          if (new_wrapper === null) {
            console.log('Invalid response. No wrapper found.');
            return;
          }

          var data = {
            'wrapper'              : new_wrapper,
            'items'                : new_wrapper.querySelector(args.selector_items),
            'pagination'           : new_wrapper.querySelector(args.selector_pagination),
            'pagination_container' : new_wrapper.querySelector(args.selector_pagination_container),
            'filters'              : new_wrapper.querySelector(args.selector_filters),
            'filter_items'         : new_wrapper.querySelectorAll(args.selector_filter_items),
            'form'                 : new_wrapper.querySelector(args.selector_form),
            'form_wrapper'         : new_wrapper.querySelector(args.selector_form_wrapper),
            'progress'             : new_wrapper.querySelector(args.selector_progress),
            'hero'                 : html.querySelector(args.selector_hero)
          };

          /**
           * Replace title with target title
           */
          document.title = html.title;

          /**
           * Set URL for browser history
           */
          if (window.history.replaceState) {
            window.history.replaceState({}, document.title, params.replace_url);
          }

          /**
           * Handle items
           */
          if (data.items) {

            // add entrance effect
            var children = data.items.childNodes;

            for (var i = 0; i < children.length; i++) {
              if (typeof children[i].classList !== 'undefined') {
                children[i].classList.add('animation--entrance');
              }
            }
            if (params.replace_items) {
              el.items.classList.add('animation--entrance');
              el.items.innerHTML = data.items.innerHTML;
            } else {
              el.items.innerHTML += data.items.innerHTML;
            }

          }

          /**
           * Handle filters
           */
          if (data.filters && el.filters) {
            el.filters.innerHTML = data.filters.innerHTML;
          }

          /**
           * Handle form_wrapper
           */
          if (data.form_wrapper && el.form_wrapper) {
            el.form_wrapper.innerHTML = data.form_wrapper.innerHTML;
          }
          /**
           * Handle progress
           */
          if (data.progress && el.progress) {
            el.progress.innerHTML = data.progress.innerHTML;
          }

          /**
           * Handle hero
           */
          if (data.hero && el.hero) {
            el.hero.innerHTML = data.hero.innerHTML;
          }

          /**
           * Pagination
           */
          if (params.is_pagination === true) {
            if (data.pagination && el.pagination) {
              el.pagination.href = data.pagination.href;
              el.wrapper.classList.remove('state--no-more-results');
              el.progress.classList.remove('state--no-more-results');
            } else {
              el.wrapper.classList.add('state--no-more-results');
              el.progress.classList.add('state--no-more-results');
            }
          } else {
            // remove existing button
            el.wrapper.classList.remove('state--no-more-results');
            if (el.pagination_container) {
              el.pagination_container.remove();
            }
            if (data.pagination_container) {
              _el_insert_after(data.pagination_container, el.items);
            }

          }

          // Reset hooks for new and old elements
          _setup_hooks();

          // Remove ajax "state"
          el.wrapper.classList.remove('state--loading');
          el.wrapper.classList.remove('state--loading-big');

          /**
           * Animation time
           */
          setTimeout(function(){
            var animation_items = document.querySelectorAll('.animation--entrance');
            if (animation_items.length) {
              for (var i = animation_items.length - 1; i >= 0; i--) {
                if (typeof animation_items[i].classList !== 'undefined') {
                  // stagger item animations
                  setTimeout(function(item) {
                    item.classList.remove('animation--entrance');
                  }, 50 * parseInt(i), animation_items[i]);
                }
              }
            }
          }, 250);

          // reinit macy.js
          macy.reInit();

        })
        .catch(function (error) {
          console.log(error);
        });

    }
    state = '';

  }

  /**
   * Handle pagination
   */
  var trigger_pagination = function(e) {

    e.preventDefault();
    var current_url = window.location.href.replace(location.hash,"");
    var loar_arg = e.currentTarget.getAttribute('data-load-param');
    var load_val = _get_parameter_by_name(loar_arg);
    if (typeof load_val == 'object') {
      load_val = 1;
    }

    run({
      'target_url'    : e.currentTarget.getAttribute('href'),
      'replace_url'   : _update_query_string_parameter(current_url, loar_arg, parseInt(load_val) + 1),
      'replace_items' : false,
      'is_pagination' : true
    });

  }

  /**
   * Handle filtering
   */
  var trigger_filter = function(e) {
    e.preventDefault();

    // toggle active class
    var current_active = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.co-ajax__filter__item__link--active');
    if (current_active) {
      current_active.classList.remove('co-ajax__filter__item__link--active');
    }
    e.currentTarget.classList.add('co-ajax__filter__item__link--active');

    // add button label
    var button = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.js-co-ajax__filter__toggle');
    if (button) {
      button.textContent = e.currentTarget.textContent;
    }

    // close toggle
    if (el.filter_toggles.length) {
      for (var i = 0; i < el.filter_toggles.length; i++) {
        el.filter_toggles[i].classList.remove('co-ajax__filter__toggle--active');
      }
    }

    run({
      'target_url'    : e.currentTarget.getAttribute('href'),
      'replace_url'   : e.currentTarget.getAttribute('href'),
      'replace_items' : true
    });

  }

  /**
   * Trigger filter list toggle
   */
  var trigger_filter_toggle = function(e) {

    var has_class = e.currentTarget.classList.contains('co-ajax__filter__toggle--active');

    if (el.filter_toggles.length) {
      for (var i = 0; i < el.filter_toggles.length; i++) {
        el.filter_toggles[i].classList.remove('co-ajax__filter__toggle--active');
      }
    }

    if (!has_class) {
      e.currentTarget.classList.add('co-ajax__filter__toggle--active');
    }

  }

  /**
   * Handle forms
   */
  var trigger_form = function(form) {

    var input = form.querySelector('input');
    if (input) {
      var url = _update_query_string_parameter(document.location.href, input.getAttribute('name'), input.value);
      run({
        'target_url'    : url,
        'replace_url'   : url,
        'replace_items' : true
      });

    }
  }

  function _setup_hooks() {

    // setup elements on current page
    el = {
      'wrapper'                         : args.wrapper,
      'items'                           : args.wrapper.querySelector(args.selector_items),
      'pagination'                      : args.wrapper.querySelector(args.selector_pagination),
      'pagination_container'            : args.wrapper.querySelector(args.selector_pagination_container),
      'filter_toggles'                  : args.wrapper.querySelectorAll(args.selector_filter_toggles),
      'filter_items'                    : args.wrapper.querySelectorAll(args.selector_filter_items),
      'filters'                         : args.wrapper.querySelector(args.selector_filters),
      'form_wrapper'                    : args.wrapper.querySelector(args.selector_form_wrapper),
      'form'                            : args.wrapper.querySelector(args.selector_form),
      'progress'                        : args.wrapper.querySelector(args.selector_progress),
      'hero'                            : document.querySelector(args.selector_hero)
    };

    // hook events to elements
    if (el.pagination !== null) {
      el.pagination.addEventListener('click', trigger_pagination);
    }

    if (el.form !== null) {
      el.form.addEventListener('submit', function(e) {
        console.log(el.form);
        e.preventDefault();
        trigger_form(el.form);
      });
    }
    if (el.filter_items.length) {
      for (var i = 0; i < el.filter_items.length; i++) {
        el.filter_items[i].addEventListener('click', trigger_filter);
      }
    }
    if (el.filter_toggles.length) {
      for (var i = 0; i < el.filter_toggles.length; i++) {
        el.filter_toggles[i].addEventListener('click', trigger_filter_toggle);
      }
    }

  }
  _setup_hooks();

  // make the call chainable
  return this;
};

/**
 * Initiate automatically
 */
document.addEventListener('DOMContentLoaded', function() {
  co_ajax_wp_query_init();
});


/**
 * Auto close toggles
 */
document.addEventListener('click', function(e) {
  var ancestors = [];
  var ancestor = e.target;
  while (ancestor !== undefined && ancestor !== null) {
    if (ancestor.classList !== undefined && ancestor.classList.contains('co-ajax__filter')) {
      ancestors.push(ancestor);
    }
    ancestor = ancestor.parentElement;
  }
  if (!ancestors.length) {
    var toggles = document.querySelectorAll('.js-co-ajax__filter__toggle');
    if (toggles.length) {
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].classList.remove('co-ajax__filter__toggle--active');
      }
    }
  }
});
